// extracted by mini-css-extract-plugin
export var discard = "_4l-3";
export var muiTooltipTooltip = "_4l-5";
export var notificationBar = "_4l-2";
export var saveButtonHoverSlotWrapper = "_4l-4";
export var show = "_4l-1";
export var spacer = "_4l-0";